import React from 'react';
import { Card, Row, Col, Statistic, Button } from 'antd';
import { PageLayout } from '../../ui';
import { 
  FileTextOutlined, 
  CarOutlined, 
  InboxOutlined, 
  DollarOutlined 
} from '@ant-design/icons';

const ReportsPage: React.FC = () => {
  return (
    <PageLayout title="Отчеты" subtitle="Аналитика и отчеты по работе системы">
      {/* Статистические карточки */}
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ backgroundColor: 'var(--card)', borderColor: 'var(--card-border)' }}>
            <Statistic
              title="Заявок в работе"
              value={24}
              prefix={<FileTextOutlined className="text-blue-500" />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ backgroundColor: 'var(--card)', borderColor: 'var(--card-border)' }}>
            <Statistic
              title="Активных маршрутов"
              value={8}
              prefix={<CarOutlined className="text-green-500" />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ backgroundColor: 'var(--card)', borderColor: 'var(--card-border)' }}>
            <Statistic
              title="Грузов на складах"
              value={156}
              prefix={<InboxOutlined className="text-orange-500" />}
              valueStyle={{ color: '#fa8c16' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ backgroundColor: 'var(--card)', borderColor: 'var(--card-border)' }}>
            <Statistic
              title="Общий оборот"
              value={12500000}
              prefix={<DollarOutlined className="text-purple-500" />}
              valueStyle={{ color: '#722ed1' }}
              suffix="₽"
            />
          </Card>
        </Col>
      </Row>

      {/* Основные разделы отчетов */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card 
            title="Отчеты по заявкам" 
            style={{ backgroundColor: 'var(--card)', borderColor: 'var(--card-border)' }}
            extra={<Button type="link" onClick={() => { /* TODO: navigate to reports */ }} style={{ color: '#1890ff' }}>Все отчеты</Button>}
          >
            <div style={{ color: 'var(--text-secondary)' }}>
              <p>Здесь будут отображаться отчеты по заявкам</p>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card 
            title="Отчеты по маршрутам" 
            style={{ backgroundColor: 'var(--card)', borderColor: 'var(--card-border)' }}
            extra={<Button type="link" onClick={() => { /* TODO: navigate to route reports */ }} style={{ color: '#1890ff' }}>Все отчеты</Button>}
          >
            <div style={{ color: 'var(--text-secondary)' }}>
              <p>Здесь будут отображаться отчеты по маршрутам</p>
            </div>
          </Card>
        </Col>
      </Row>
    </PageLayout>
  );
};

export default ReportsPage; 